import { Feature } from "./features-section/Feature"
import "./featuresSection.css"

export function FeaturesSection(){
    return (
        <div className="d-flex justify-content-center features-section md-row">
            <Feature
                feature="delivery"
                heading="FREE AND FAST DELIVERY"
                description="Free delivery for all orders over $140"
            />
            <Feature
                feature="customer-service"
                heading="24/7 CUSTOMER SERVICE"
                description="Friendly 24/7 customer support"
            />
            <Feature
                feature="secure"
                heading="MONEY BACK GUARANTEE"
                description="We reurn money within 30 days"
            />
        </div>
    )
}